import { render, staticRenderFns } from "./CouponToast.vue?vue&type=template&id=d310207c&lang=pug&"
import script from "./CouponToast.vue?vue&type=script&lang=js&"
export * from "./CouponToast.vue?vue&type=script&lang=js&"
import style0 from "./CouponToast.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports